module.exports = __webpack_public_path__ + "img/gf.e4bce01f.svg";